import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { QueryKey } from '@/Config/api/queryKey';

type UserIntentDistributionResponse = {
  user_intent_counts: Record<string, number>;
};

const toISODate = (date: Date) => format(date, 'yyyy-MM-dd');

export const useUserIntentDistribution = ({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}) => {
  const { data, isLoading } = useQuery<UserIntentDistributionResponse>({
    queryKey: [
      QueryKey.analytics.userIntentDistribution,
      { start: toISODate(startDate), end: toISODate(endDate) },
    ],
  });

  return {
    userIntentCounts: data?.user_intent_counts ?? {},
    isLoading,
  };
};
